import { Result } from '../../../../../common/models/Result';
import { HttpServiceBase } from '../../../../../common/services/HttpServiceBase';
import { MembershipLevel } from '../../../../models/MembershipLevel';

export class GetMembershipLevelListService extends HttpServiceBase {

  handle = (bearerToken: string): Promise<Result<GetMembershipLevelListOutput> | null> => {
    const promise = this.http.get<Result<GetMembershipLevelListOutput>>(
      `${this.baseUrlZerezesApi}/club-pdv/membership-level`,
      bearerToken
    );
    return promise;
  }
}

export class GetMembershipLevelListOutput {
  list?: MembershipLevel[];
}